const categories = document.querySelectorAll('.main__faq-categories .main__faq-category');
const faqItems = document.querySelectorAll('.main__faq-items .accordion__item');

if (categories.length > 0 || faqItems.length > 0) {
  function setActiveItems(handle) {
    let isFirst = false;
    faqItems.forEach(item => {
      if (item.dataset.id === handle) {
        item.style.display = 'block';

        if (!isFirst) {
          isFirst = true;
          if (item.querySelector('.accordion__content').getAttribute('style')?.includes('display: none;')) {
            item.querySelector('.accordion__trigger').click();
          }
        }
      } else {
        item.style.display = 'none';
      }
    });
  }

  function setActiveCategory(activeHandle, categoryItem) {
    const oldActive = document.querySelector('.main__faq-category.is--active');
    oldActive && oldActive.classList.remove('is--active');

    categoryItem.classList.add('is--active');
    setActiveItems(activeHandle);
  }

  setActiveItems(categories[0].dataset.id);

  categories.forEach(function (category) {
    category.addEventListener('click', function () {
      setActiveCategory(this.dataset.id, this);
    });
  });
}
